function formatDisplay(num) {
	if (num < 10) {
		return `0${num}`
	} else {
		return num
	}
}

function formatDate(date) {
	const year = date.getFullYear()
	const month = date.getMonth() + 1
	const day = date.getDate()

	const formatDate = `${year}-${formatDisplay(month)}-${formatDisplay(day)}`
	return formatDate
}

function formatTime(date) {
	date = new Date(date)
	const year = date.getFullYear()
	const month = date.getMonth() + 1
	const day = date.getDate()
	const hour = date.getHours()
	const min = date.getMinutes()
	const sec = date.getSeconds()
	const formatTime =
		`${year}-${formatDisplay(month)}-${formatDisplay(day)} ${formatDisplay(hour)}:${formatDisplay(min)}:${formatDisplay(sec)}`
	return formatTime
}

function convertYuantoCent(yuan) {
	let cent = parseInt(yuan * 100);
	return cent
}

function convertCenttoYuan(cent) {
	let yuanStr = (cent / 100).toFixed(2);
	// yuanStr+="";
	// var reg = yuanStr.indexOf('.') >-1 ? /(\d{1,3})(?=(?:\d{3})+\.)/g : /(\d{1,3})(?=(?:\d{3})+$)/g;
	// yuanStr=yuanStr.replace(reg,'$1');
	return yuanStr
}
// 此方法用于对一个对象数组中的所有数字属性求和
function dailyStatistic(arr,obj){
	if(arr.length>0){
		let keyArr =Object.keys(arr[0]) 
		for(let i = 0;i<arr.length;i++ ){
			keyArr.forEach(_item=>{
				if(!isNaN(arr[i][_item])){
					obj[_item] = obj[_item]?obj[_item]+arr[i][_item]:arr[i][_item]
				}
			})
		}
		return obj
	}else{
		return obj
	}
}
function formatPercent(num){
	return isNaN(num)?"NaN":(parseFloat(num)*100).toFixed(2)+"%";
}
function handleFileSize(specInfo) {
	// 本方法接受的是由后端接口从规格表中查出的“标准”规格信息对象
	let fileSize = '';
	if (specInfo.file_size_min && specInfo.file_size_max) {
		fileSize = parseInt(specInfo.file_size_min / 1024) + "KB ~" + parseInt(specInfo.file_size_max / 1024) + "KB"
	} else if (specInfo.file_size_min) {
		fileSize = '不小于' + ((specInfo.file_size_min) / 1024) + 'KB'
	} else if (specInfo.file_size_max) {
		fileSize = '不大于' + ((specInfo.file_size_max) / 1024) + 'KB'
	} else {
		fileSize = "无要求" 
	}
	return fileSize
}
export {
	formatDate,
	formatTime,
	convertYuantoCent,
	convertCenttoYuan,
	dailyStatistic,
	formatPercent,
	handleFileSize
}
